(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-main-bundles"]) return;
  try {
    
const itemBtn = document.querySelectorAll('[data-grid-item]');
let nowProductUrl = '';
if (itemBtn.length > 0) {
itemBtn.forEach(element => {
element.addEventListener('click', async event => {
event.preventDefault();
const { target } = event;
const url = `${target.href}`;
UIkit.modal('#js-product-modal').show();
if (url === nowProductUrl) return;

document.querySelector('[data-quick-container]').innerHTML = `<div class="uk-position-cover uk-flex uk-flex-center uk-flex-middle"><i uk-spinner="ratio: 1.3;"></i></div>`;
nowProductUrl = url;
const source = await fetch(url)
.then((response) => response.text())
.then((responseText) => {
const html = new DOMParser().parseFromString(responseText, 'text/html')
return html.querySelector('[data-main-product]')
});

if (source) {
document.querySelector('[data-quick-container]').innerHTML = source.innerHTML;
Shopify.PaymentButton.init();
try {
affirm.ui.refresh()
} catch (e) {
console.error(e)
}
}
})
})
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-cart-dropdown"]) return;
  try {
    
UIkit.util.query('#js-pop')?UIkit.util.query('#js-pop').addEventListener('hidden', () => UIkit.offcanvas('#cart-offcanvas-nav').show()):"";

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-slideshow_1"] && !Shopify.designMode) return;
  try {
    
class SliderShow extends HTMLElement {
constructor() {
super();
this.init = this.init.bind(this);
this.config = JSON.parse(this.querySelector('[data-config]').dataset.config);

this.init();
window.addEventListener('resize', Shopify.debounce(this.init, 1000));
}
init() {
const {offsetWidth} = document.documentElement;
const {ratioMobile, ratioPc, ratioTable} = this.config;
if (offsetWidth <= 760) {
UIkit.slideshow(this, Object.assign(this.config, {ratio: ratioMobile}));
} else if (offsetWidth <= 1440) {
UIkit.slideshow(this, Object.assign(this.config, {ratio: ratioTable}));
} else {
UIkit.slideshow(this, Object.assign(this.config, {ratio: ratioPc}));
}
}
}
customElements.define('slider-show', SliderShow)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
class CartNote extends HTMLElement {
constructor() {
super();

this.addEventListener('change', debounce((event) => {
const body = JSON.stringify({ note: event.target.value });
fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
}, 300))
}
}
customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tech-specs"] && !Shopify.designMode) return;
  try {
    
const nullState = `<div class="uk-container uk-position-relative uk-section-small uk-padding-remove-top"><span class="uk-h4">Null</span></div>`;
class tabs {
    constructor(container) {
        this.state = {
            cacheData: {},
        }
        this.selectors = {
            tabButtons: container.querySelectorAll('[data-tech-handle]'),
            tabContent: container.querySelector('[data-tech-content]')
        }
        if (this.selectors.tabButtons.length) { this.init() }
    }
    init() {
        const { state, selectors } = this;
        const { cacheData } = state;
        const { tabButtons, tabContent } = selectors;
        const key = `TAB0`;
        const fistTabHandle = tabButtons[0].dataset.techHandle;
        // if (location.href.indexOf(fistTabHandle) == -1) {
        //     cacheData[key] = tabContent.innerHTML;
        // } else {
        //     this.updateSections(0, tabButtons[0].dataset.techHandle);
        // }
 this.updateSections(0, tabButtons[0].dataset.techHandle);
        tabButtons.forEach((element, index) => {
            element.addEventListener('click', (event) => {
                event.target.closest('ul').querySelectorAll('li').forEach(e => e.classList.remove('tm-active'))
                event.target.closest('li').classList.add('tm-active');
                this.updateSections(index, event.target.dataset.techHandle);
            }, false);
        })
    }
    async updateSections(index, url) {
        const key = `TAB${index}`
        const { state, selectors } = this;
        const { cacheData } = state;
        const { tabContent } = selectors;
        if (!cacheData[key]) {
            const data = await this.requestData(url);
            tabContent.innerHTML = cacheData[key] = data ? data : nullState;
        } else {
            tabContent.innerHTML = cacheData[key];
        }
    }
    async requestData(url) {
        return await fetch(url).then((response) => response.text()).then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            return html.querySelector('[data-tech-content]')?.innerHTML;
        });
    }
}
new tabs(document.querySelector('[data-section-type="product-tech-specs"]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["public-collection"] && !Shopify.designMode) return;
  try {
    
const itemBtn = document.querySelectorAll('[data-grid-item]');
let nowProductUrl = '';
if (itemBtn.length > 0) {
  itemBtn.forEach(element => {
    element.addEventListener('click', async event => {
      event.preventDefault();
      const { target } = event;
      const url = `${target.href}`;
      UIkit.modal('#js-product-modal').show();
      if (url === nowProductUrl) return;

      document.querySelector('[data-quick-container]').innerHTML = `<div class="uk-position-cover uk-flex uk-flex-center uk-flex-middle"><i uk-spinner="ratio: 1.3;"></i></div>`;
      nowProductUrl = url;
      const source = await fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          return html.querySelector('[data-main-product]')
        });

      if (source) {
        document.querySelector('[data-quick-container]').innerHTML = source.innerHTML;
        Shopify.PaymentButton.init();
        try {
          affirm.ui.refresh()
        } catch (e) {
          console.error(e)
        }
      }
    })
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light');
      this.initSlideshow(this.firstType);
      this.init();
    }

    initSlideshow(flag) {
      document.querySelector('.tm-header').classList.toggle('uk-light', flag);
    }

    init() {
      this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
        const is_light = e.target.classList.contains('uk-light');
        this.initSlideshow(is_light);
      });
    }
  }
  new Slideshow(document.querySelector('[data-section-type="slideshow"]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-faqs"] && !Shopify.designMode) return;
  try {
    
let flag = false;
const showString = {
show: "Show More",
close: "Close"
}
document.querySelectorAll('[data-group]').forEach(element => {
const oBtn = element.querySelector('button');
if (oBtn) {
oBtn.addEventListener('click', (e) => {
flag = !flag;
e.target.innerHTML = flag ? showString.close : showString.show;
element.querySelector('[uk-accordion]').classList.toggle('open', flag)
});
}
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-page-eb70"]) return;
  try {
    
new WOW().init();

  } catch(e) { console.error(e); }
})();
})();
